import { useInvoiceTypeToLabelDictionary } from "@jugl-web/rest-api/invoices/hooks/useInvoiceTypeToLabelDictionary";
import { TextInput } from "@jugl-web/ui-components/cross-platform";
import { useTranslations } from "@jugl-web/utils";
import { useInvoicesItemFormPageContext } from "@web-src/modules/invoices/pages/InvoicesItemFormPage/context/useInvoicesItemFormPageContext";

export const NoField = () => {
  const { t } = useTranslations();
  const { type, id, invoiceItemData } = useInvoicesItemFormPageContext();
  const dict = useInvoiceTypeToLabelDictionary();

  return (
    <TextInput
      isDisabled
      placeholder={
        id
          ? invoiceItemData.no
          : t({
              id: "common.auto",
              defaultMessage: "Auto generated",
            })
      }
      label={`${dict[type || "invoice"]} No.`}
    />
  );
};
